import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

function GalleryItem({info}) {
    const navigate = useNavigate();
    const params = useParams();
    const slug = params['*'];

    const props = info?.extra?.props || {};
    const columns = info?.template?.columns || [];
    const gridColsClass = `cols-${Math.min(columns.length, 3)}`;

    const renderProperty = (prop) => {
        const name = prop.name;
        const value = props[name];
        if (value == null || value === "") return null;

        const label = prop.show_name ? (
            <div style={{ fontSize: '0.85rem', color: '#777', marginBottom: '4px', textAlign: 'center' }}>{name}</div>
        ) : null;

        if (prop.type === 'image') {
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <img src={value} alt={name} style={{ maxWidth: '100%', borderRadius: '8px', display: 'block', margin: '0 auto' }} />
                </div>
            );
        }

        if (prop.type === 'line') {
            const fontSize = prop.meta.fontSize === 'heading' ? '2rem' : prop.meta.fontSize === 'sub-heading' ? '1.5rem' : '1rem';
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5, fontSize }}>{prop.meta.prefix} {value} {prop.meta.suffix}</div>
                </div>
            );
        }

        if (prop.type === 'text') {
            return (
                <div key={name} style={{ marginBottom: '16px', textAlign: 'center' }}>
                    {label}
                    <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{value}</div>
                </div>
            );
        }

        // default: 'line' or other simple types
        return (
            <div key={name} style={{ marginBottom: '12px', textAlign: 'center' }}>
                {label}
                <div>{value}</div>
            </div>
        );
    };

    return (
        <div className="justify" style={{ width: '100%' }}>
            {/* Inline styles for responsive grid to minimize changes across files */}
            <style>{`
              .template-grid { display: grid; gap: 16px; width: 100%; align-items: stretch; }
              .template-col { padding: 16px; display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; }
              /* Mobile: single column */
              @media (max-width: 599px) { 
                .template-grid { grid-template-columns: 1fr; }
              }
              /* >=600px: set columns to available count (max 3) */
              @media (min-width: 600px) {
                .template-grid.cols-1 { grid-template-columns: 1fr; }
                .template-grid.cols-2 { grid-template-columns: repeat(2, 1fr); }
                .template-grid.cols-3 { grid-template-columns: repeat(3, 1fr); }
              }
            `}</style>

            <div className="justify">
                {typeof info.body === "string" ? parse(info.body) : null}
            </div>

            {columns.length > 0 && (
                <div className={`template-grid ${gridColsClass}`} style={{ width: '100%' }}>
                    {columns.map((col, cIdx) => (
                        <div key={cIdx} className="template-col">
                            {(col.properties || []).map(renderProperty)}
                        </div>
                    ))}
                </div>
            )}

            <button
                style={{
                    background: "#fff",
                    border: "1px solid #aaa",
                    borderRadius: "6px",
                    padding: "8px 20px",
                    fontSize: "1rem",
                    color: "#aaa",
                    cursor: "pointer",
                    transition: "background 0.2s, color 0.2s",
                    display: "block",
                    margin: "32px auto 0 auto"
                }}
                onClick={() => navigate(`/${slug.split('/').slice(0, -1).join('/')}`)}
            >
                Go Back
            </button>
        </div>
    );
}

export default GalleryItem;